module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "duplicate-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "duplicate-template"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('duplicate-template.Name')
    }
  }, [_c('label', [_vm._v("Template Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duplicateName),
      expression: "duplicateName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.duplicateName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.duplicateName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('duplicate-template.Name')),
      expression: "errors.has('duplicate-template.Name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('duplicate-template.Name')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button duplicated-btn",
    attrs: {
      "data-style": "expand-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.runDuplicate.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Duplicate Template")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("DUPLICATE TEMPLATE SETTINGS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3945f101","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/DuplicateTemplateModal.vue
// module id = 1610
// module chunks = 1